
import React from 'react';
import { Target } from 'lucide-react';

const Purpose: React.FC = () => {
  return (
    <section id="purpose" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center p-3 bg-white rounded-2xl shadow-sm mb-8">
          <Target className="text-avus-blue" size={32} />
        </div>
        <h2 className="text-4xl font-bold text-avus-navy mb-8 tracking-tight">Our Purpose</h2>
        <div className="max-w-3xl mx-auto">
          <p className="text-2xl text-slate-600 font-light leading-relaxed italic">
            "To simplify business operations by providing dependable administrative and support services that allow organizations to focus on growth, performance, and value creation."
          </p>
          <div className="mt-10 flex justify-center space-x-2">
            <span className="w-2 h-2 rounded-full bg-avus-blue"></span>
            <span className="w-2 h-2 rounded-full bg-avus-accent"></span>
            <span className="w-2 h-2 rounded-full bg-avus-light"></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Purpose;
